import OlMap from 'ol/Map'
import { Extent } from 'ol/extent'
import { Geometry } from 'ol/geom'

import { getRegionFeatureMetadata } from '../../../../layers/region/regionFeatureMetadata'
import { findLayer } from '../../../../layers/utils/findLayer'
import { createNonBlockingRenderByTime } from '../../../../renderingQueue'

const nonblockingRender = createNonBlockingRenderByTime()

export async function selectRegionFeatureInExtent(
  map: OlMap,
  lassoPolygon: Geometry,
  lassoExtent: Extent,
) {
  const regionLayer = findLayer(map, 'region')
  const selectedIds: string[] = []

  const featuresInExtent = regionLayer.getSource()?.getFeaturesInExtent(lassoExtent) ?? []

  nonblockingRender.reset()

  for (const feature of featuresInExtent) {
    await nonblockingRender.next()

    const mode = getRegionFeatureMetadata(feature, 'mode')
    if (mode === 'off') continue

    const recordId = feature.getId() as string

    if (recordId) {
      const extent = feature.getGeometry()?.getExtent()

      if (extent && lassoPolygon.intersectsExtent(extent)) {
        selectedIds.push(recordId)
      }
    }
  }

  return selectedIds
}
